import { useEffect, useState } from "react";
import { useQuestionizerStore } from "../types/state.ts";
import { FDWAntragsteller, FDWResultEntry } from "restfd2";
import Checkbox from "./checkbox.tsx";
import LoadingIndicator from "./loading-indicator.tsx";
import Input from "./input.tsx";
import { DoiForm, LeadForm } from "./lead_form.tsx";
import { QuestionizerResultSummary } from "./questionizer-result-summary.tsx";
import { QuestionizerResultTeaser } from "./questionizer-result-teaser.tsx";
import { QuestionizerResultTabs } from "./questionizer-result-tabs.tsx";

export default function QuestionizerResult(props: {id: number}){
    const result = useQuestionizerStore((state) => state.result);
    const session_id = useQuestionizerStore((state) => state.session_id);
    const gemeinde_id = useQuestionizerStore((state) => state.gemeinde_id);
    const gewerk = useQuestionizerStore((state) => state.gewerk);
    const gebaeude = useQuestionizerStore((state) => state.gebaeude);
    const typ = useQuestionizerStore((state) => state.typ);
    const baujahr = useQuestionizerStore((state) => state.baujahr);
    const wohngebaeude = useQuestionizerStore((state) => state.wohngebaeude);
    const gewerbegebaude = useQuestionizerStore((state) => state.gewerbegebaeude);
    const gemeinnuetzig = useQuestionizerStore((state) => state.gemeinnuetzig);
    const requestResult = useQuestionizerStore((state) => state.requestResult);
    const antragsteller = useQuestionizerStore((state) => state.antragsteller);
    const antragsteller_detail = useQuestionizerStore((state) => state.antragsteller_detail);
    const lead_sended = useQuestionizerStore((state) => state.lead_sended);
    const call_request_sent = useQuestionizerStore((state) => state.call_request_sent);
    const use_doi = true && useQuestionizerStore((state) => state.config?.use_doi);
    const doi_confirm = true && useQuestionizerStore((state) => state.doi_confirm);

    const show_lead_form = useQuestionizerStore((state) => state.config?.show_lead_form);
    const show_call_request_form = useQuestionizerStore((state) => state.config?.show_call_request_form);

    useEffect(()=>{
      requestResult();
   },[session_id, gebaeude, typ, baujahr, wohngebaeude, gewerbegebaude, gemeinnuetzig, gemeinde_id, gewerk, antragsteller_detail, antragsteller]);

    if (session_id == undefined || result == undefined){
      return <div className={"col-span-12 input-"+props.id}><LoadingIndicator /></div>
    }

    console.log("->", use_doi, show_lead_form);
    return (<div className={"col-span-12 input-"+props.id}>
        <QuestionizerResultSummary />
        {(use_doi && !doi_confirm) && <QuestionizerResultTeaser />}
        {show_call_request_form && !call_request_sent && <LeadForm/>}
        {((show_lead_form && !lead_sended) || (use_doi && !doi_confirm)) && <DoiForm/>}
        {(!show_lead_form || lead_sended) && (!use_doi || doi_confirm) && <QuestionizerResultTabs/>}
    </div>);  
  }